import { connect } from 'react-redux';
import { formValueSelector } from 'redux-form';
import React, { useEffect } from 'react';

import { JOURNEY_BUILDER_FORM_NAME } from '../../../../constants/JourneyBuilder';
import ListObjectField from './ListObjectField';

export const getOptions = (dependentsOnFieldValue, criteria) => {
  const options =
    dependentsOnFieldValue &&
    criteria &&
    criteria.options &&
    criteria.options[dependentsOnFieldValue];
  return options ? options : [];
};

export const DependentListObjectField = ({
  name,
  onChange,
  readonlyForm,
  metaData,
  criteria,
  dependentsOnFieldValue,
  setFormValueDispatch,
  label,
}) => {
  const dependentsOnFieldName = criteria && criteria.dependentsOnFieldName;

  useEffect(
    () => {
      const options = getOptions(dependentsOnFieldValue, criteria);
      if (options && options.length > 0) {
        setFormValueDispatch(name, options[0].value);
        onChange(options[0].value);
      }
    },
    [metaData && metaData.fieldValues && metaData.fieldValues[dependentsOnFieldName]]
  );
  return (
    <ListObjectField
      name={name}
      label={label}
      readonlyForm={readonlyForm}
      options={getOptions(dependentsOnFieldValue, criteria)}
      onChange={onChange}
    />
  );
};

DependentListObjectField.displayName = 'DependentListObjectField';

const selector = formValueSelector(JOURNEY_BUILDER_FORM_NAME);

export const mapStateToProps = (state, ownProps) => {
  const { dependentsOnField } = ownProps;

  const dependentsOnFieldValue = selector(state, dependentsOnField.formFieldName);
  return { dependentsOnFieldValue };
};

export const getDependentOptions = (field, fieldValues) => {
  const dependentsOnFieldName = field && field.criteria && field.criteria.dependentsOnFieldName;
  const dependentsOnFieldValue =
    dependentsOnFieldName && fieldValues && fieldValues[dependentsOnFieldName];
  const dependentOptions = getOptions(dependentsOnFieldValue, field.criteria);
  return dependentOptions;
};

export default connect(
  mapStateToProps,
  {}
)(DependentListObjectField);



// WEBPACK FOOTER //
// ./src/JourneyBuilder/DecisionSplit/components/Path/PathObjectFields/DependentListObjectField.js